import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const IconParticipationProjects: React.FC<SvgIconProps> = ({sx}) => (
  <SvgIcon
    viewBox="0 0 28 28"
    sx={{
      color: COLORS.CERULEAN,
      width: 28, 
      height: 28,
      ...sx,
    }}
  >
    <path 
        d="M11.9958 20.9983H6.6961C5.81282 20.9983 5.06542 20.2509 5.06542 19.3676V3.94415C5.06542 3.06087 5.81282 2.31347 6.6961 2.31347H16.3443C17.2276 2.31347 17.975 3.06087 17.975 3.94415V14.7474C18.5185 14.6115 19.0621 14.5436 19.6056 14.5436C19.8095 14.5436 20.0133 14.5436 20.2171 14.5436V3.94415C20.1492 1.76991 18.4506 0.0712891 16.2763 0.0712891H6.6961C4.52186 0.0712891 2.82324 1.76991 2.82324 3.94415V19.3676C2.82324 21.4739 4.52186 23.1726 6.6961 23.1726H11.9279C11.8599 22.8328 11.8599 22.5611 11.8599 22.2213C11.8599 21.8137 11.9279 21.406 11.9958 20.9983Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M15.3927 4.35205H7.57901C7.1034 4.35205 6.76367 4.69178 6.76367 5.16739C6.76367 5.643 7.17134 5.98273 7.57901 5.98273H15.3927C15.8683 5.98273 16.208 5.643 16.208 5.16739C16.208 4.69178 15.8683 4.35205 15.3927 4.35205Z"
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M15.3927 7.68115H7.57901C7.1034 7.68115 6.76367 8.02088 6.76367 8.49649C6.76367 8.97211 7.1034 9.31183 7.57901 9.31183H15.3927C15.8683 9.31183 16.208 8.97211 16.208 8.49649C16.208 8.02088 15.8683 7.68115 15.3927 7.68115Z"
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M15.3927 10.9424H7.57901C7.1034 10.9424 6.76367 11.2821 6.76367 11.7577C6.76367 12.2333 7.1034 12.5731 7.57901 12.5731H15.3927C15.8683 12.5731 16.208 12.2333 16.208 11.7577C16.208 11.2821 15.8683 10.9424 15.3927 10.9424Z"
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M12.6085 14.5537H7.5126C7.03699 14.5537 6.69727 14.8934 6.69727 15.3691C6.69727 15.8447 7.03699 16.1844 7.5126 16.1844H12.5405C13.0161 16.1844 13.3559 15.8447 13.3559 15.3691C13.3559 14.8934 13.0161 14.5537 12.6085 14.5537Z"
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M19.5379 16.6499C16.4124 16.6499 13.8984 19.1639 13.8984 22.2893C13.8984 25.4148 16.4124 27.9288 19.5379 27.9288C22.6633 27.9288 25.1773 25.4148 25.1773 22.2893C25.1773 19.1639 22.6633 16.6499 19.5379 16.6499ZM19.5379 26.434C17.2277 26.434 15.3932 24.5315 15.3932 22.2893C15.3932 20.0471 17.2957 18.1447 19.5379 18.1447C21.78 18.1447 23.6825 20.0471 23.6825 22.2893C23.6825 24.5315 21.848 26.434 19.5379 26.434Z"
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M22.3913 20.4549C22.1195 20.251 21.7119 20.251 21.508 20.5228L18.9261 23.5803L17.7031 21.9497C17.4993 21.6779 17.0916 21.6099 16.8198 21.8138C16.5481 22.0176 16.4801 22.4253 16.6839 22.697L18.3826 24.9392C18.5185 25.0751 18.6544 25.211 18.8582 25.211C19.062 25.211 19.1979 25.1431 19.3338 25.0072L22.4593 21.3381C22.6631 21.0664 22.6631 20.6587 22.3913 20.4549Z"
        stroke="none"
        fill="currentColor"
    />
  </SvgIcon>
)
